<template>
  <label
    class="relative inline-flex cursor-pointer items-center"
    :class="{
      'mb-5': !showNewDesktopPlpQuickFilters,
    }"
  >
    <input
      type="checkbox"
      class="peer sr-only"
      :checked="modelValue"
      :aria-label="ariaLabel"
      @click.stop="toggle"
    />
    <div
      class="peer h-5 w-9 rounded-full border after:absolute after:left-1 after:top-1 after:size-3 after:rounded-full after:bg-black after:transition-all after:content-[''] peer-checked:after:translate-x-4 peer-checked:after:bg-green peer-focus:ring-2"
      :class="{
        'after:bg-black-40': isMuted,
      }"
    ></div>
  </label>
</template>

<script lang="ts">
export default defineComponent({
  name: 'Toggle',

  props: {
    modelValue: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isMuted: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    ariaLabel: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
  },
  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const { showNewDesktopPlpQuickFilters } = useExperiments()
    const toggle = () => emit('update:modelValue', !props.modelValue)

    return { toggle, showNewDesktopPlpQuickFilters }
  },
})
</script>
